export default __webpack_public_path__ + "static/media/box-2CLosed.18cfb6c8.jpg";